// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__148H4","slickslide":"carousel_slickslide__1e1bt","slideImg":"carousel_slideImg__2Rh2E"};